
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.956 43.643c-.26 0-.51-.1-.71-.289L21.848 31.01a.988.988 0 010-1.404L34.217 17.29a.999.999 0 011.41 0 .989.989 0 010 1.404L23.967 30.302l11.698 11.649a.988.988 0 01-.71 1.692z"}}),_c('path',{attrs:{"d":"M29.607 52.713c-12.408 0-22.496-10.046-22.496-22.4 0-12.356 10.088-22.401 22.496-22.401s22.497 10.045 22.497 22.4c0 12.355-10.089 22.4-22.497 22.4zm0-42.81c-11.298 0-20.497 9.16-20.497 20.41s9.199 20.409 20.497 20.409 20.497-9.16 20.497-20.41S40.905 9.903 29.607 9.903z"}})])
          )
        }
      }
    